import { RADAR_EXTRAS } from "@/lib/clients";

// Radar add-ons (MPC Marketplace, LinkedIn Follow-Ups, Market Intelligence): on unless set to false.
export const ExtraChips = ({ mods, onToggle, chip, prefix }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${prefix}-extras`}>
    {RADAR_EXTRAS.map(([k, l]) => <button type="button" key={k} onClick={() => onToggle(k, mods?.[k] === false)} className={chip(mods?.[k] !== false)} data-testid={`${prefix}-${k}`}>{l}</button>)}
  </div>
);
